/** Shared dark shell — same for all offers (no creative skew). */
export const CROSS_SELL_SHELL_BG =
  "linear-gradient(105deg, #0f172a 0%, #1e1b4b 55%, #111827 100%)";

export const CROSS_SELL_CTA_TEXT = "#0f172a";
